import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ReplicaApp from "./replica/ReplicaApp";
import { routeAliases } from "./replica/routeAliases";
import reportWebVitals from "./reportWebVitals";
import WebFont from "webfontloader";
import { AuthProvider } from "./context/AuthContext";
import { BetSlipProvider } from "./context/BetSlipContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
if (routeAliases[window.location.pathname]) {
  window.history.replaceState(null, "", routeAliases[window.location.pathname] + window.location.search);
}
WebFont.load({
  google: {
    families: ["Inter", "Lato", "Ubuntu"],
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <React.StrictMode>
  <>
    <ToastContainer position="top-right" autoClose={2000} draggable />
    {window.location.pathname.startsWith("/m/") || window.location.pathname === "/replica" ? <ReplicaApp /> : <App />}
  </>
  // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
